var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteXIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "X_icon Copy") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "X_icon-Copy",
  fill: "#FFFFFF",
  transform: "translate(5.899495, 5.899495) rotate(-45.000000) translate(-5.899495, -5.899495) ",
  points: "6.89949494 4.89949494 12.8994949 4.89949494 12.8994949 6.89949494 6.89949494 6.89949494 6.89949494 12.8994949 4.89949494 12.8994949 4.89949494 6.89949494 -1.10050506 6.89949494 -1.10050506 4.89949494 4.89949494 4.89949494 4.89949494 -1.10050506 6.89949494 -1.10050506"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteXIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white-x-icon.84a790558aab6fb2cb0f511de4176c54.svg";